<div>
    <a target="_blank" href="https://www.tcgplayer.com/search/all/product?seller=aedae180&view=grid">TCGPlayer</a>
    - My card shop, mainly Sorcery but will sell anything I can find
</div>
<div>
    <a target="_blank" href="https://www.ebay.com/usr/ryes_above">eBay</a>
    - Same as above, really -- though I'm not limited to cards here
</div>
<div>
    <a target="_blank" href="https://addons.mozilla.org/en-US/firefox/addon/cloaker/">Cloaker</a>
    - An extension I made to persistently hide HTML elements on websites
</div>

<h3>Interesting External Links</h3>
<div>
    <a target="_blank" href="https://www.sirlin.net/ptw-book/introducingthe-scrub">Introducing...the Scrub</a>
    - How covert contracts prevent game players from molding to the rules and improving
</div>
<div>
    <a target="_blank" href="https://www.youtube.com/@ActionableIntelligenceAlert">John Polomny</a>
    - A retired energy worker who now focuses on investing from a fundamental view, weekly videos are always worth a
    watch
</div>